import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import util from 'util';
import { useToasts } from 'react-toast-notifications';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading.js';
import Modal from 'react-modal';
import { generatePath } from 'react-router';
import { useHistory } from 'react-router-dom';

const Lottery = (props) => {
  // props
  const { user } = props;
  const history = useHistory();

  // チケットデータ
  const [customerTicketList, setCustomerTicketList] = useState(null); // 顧客の抽選券データ
  // const [originCustomerTicketList, setOriginCustomerTicketList] = useState(null); // 顧客の抽選券データ
  const [benefitTicketList, setBenefitTicketList] = useState(null);
  // const [originBenefitTicketList, setOriginBenefitTicketList] = useState(null);   // 特典ごとの抽選券マスタ
  const [selectEntry, setSelectEntry] = useState(null);
  const [lotteryFlg, setLotteryFlg] = useState(false);

  // 抽選対象データ
  const [sortOrder, setSortOrder] = useState([]);
  const [lockData, setLockData] = useState(false);  
  const [loscComfirmFlg, setLoscComfirmFlg] = useState(false);
  const [lotteryTarget, setLotteryTarget] = useState(constClass.FLAG.OFF)
  const [prevMonthAmount, setPrevMonthAmount] = useState({});
  const [prevMonthMall, setPrevMonthMall] = useState({});
  const { addToast } = useToasts();  

  // const [monthOptions, setMonthOptions] = useState([]);
  // const [selectedMonth, setSelectedMonth] = useState(null);
  // const [rankOptions, setRankOptions] = useState([]);
  // const [selectedRank, setSelectedRank] = useState(null);

  const jwt = localStorage.getItem('jwt');

  const modalConfirmStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.5)"
    },
    content: {
      position: "absolute",
      left: '20%',
      right: '20%',
      top: '25%',
      bottom: 'auto',
      borderRadius: "0rem",
      padding: "0px",
      height: "auto",
      maxHeight: "60%",
      width: "60%",
      overflowX: "hidden",
      overflowY: "scroll",
    }
  };
  // データ取得（顧客抽選券・特典マスタ）
  const refreshMaster = useCallback(async () => {    
    const params = {
      site_id: props.match.params.siteId,
      operator: "and",
      where: [{ site_id: props.match.params.siteId }]
    };

    const benefitTickets = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/${props.match.params.siteId}/`, {
      headers: { Authorization: `Bearer ${jwt}` }
    })).data;
    setBenefitTicketList(benefitTickets);

    const customerTickets = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer_benefit_lottery_ticket/search/`, params, {
      headers: { Authorization: `Bearer ${jwt}` }
    })).data;

    // const options = [
    //   { value: '', label: '抽選年月を選択してください' },
    //   ...benefitTickets.flatMap(ticket => ticket.m_benefit_lottery_ticket_yearmonth)
    //     .map(row => {
    //       const y = row.year_month.slice(0, 4);
    //       const m = row.year_month.slice(4, 6).replace(/^0/, '');
    //       return {
    //         value: `${y}${m.padStart(2, '0')}`,
    //         label: `${y}年${m}月`
    //       };
    //     })
    //     .filter((option, index, self) => index === self.findIndex(o => o.value === option.value))
    // ];
    // setMonthOptions(options);
    // if (options.length > 0) setSelectedMonth(options[0]);

    const res = customerTickets.map((item) => item = {
      ...item,
      lottery_status: item.status,
      old_lottery_status: item.status,
    });

    setCustomerTicketList(res);
    setSelectEntry(null);
    setLotteryFlg(false);

  }, [props.match.params.siteId, jwt]);

  //登録
  // 抽選結果登録
  const submitLottery = async () => {
    const jwt = localStorage.getItem('jwt');
    try {
      const changedList = getTargetSearch(selectEntry)
        .filter(item => item.lottery_status !== item.old_lottery_status)
        .map(item => ({
          site_id: item.site_id,
          customer_id: item.customer_id,
          issue_count: item.issue_count,
          status: item.lottery_status,
          lottery: item.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN ? constClass.FLAG.ON : item.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE ? constClass.FLAG.OFF : "",
          sent_mall_id: item.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN ? prevMonthMall[item.customer_id] || 1 : null,
          upd_date: item.upd_date
        }));
      if (changedList.length <= 0) {
        window.alert(`更新されていません`);
        return;
      }
      if (window.confirm(`抽選結果を登録します。よろしいですか？`)) {
        const form = new FormData();
        form.append("site_id", props.match.params.siteId);
        form.append("user_id", user.userId);
        form.append("lotterylist", JSON.stringify(changedList));              
        
        const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer_benefit_lottery_ticket/lottery`, form, {
          headers: {
            Authorization: `Bearer ${jwt}`,
            'content-type': 'multipart/form-data',
          }
        });
        addToast("抽選結果を登録しました", { appearance: 'success', autoDismiss: true });
        const updatedList = customerTicketList.map(item => ({
          ...item,
          status: (result.data && result.data.lotteryticket && result.data.lotteryticket.find(r => r.customer_id === item.customer_id && r.issue_count === item.issue_count)) ? result.data.lotteryticket.find(r => r.customer_id === item.customer_id && r.issue_count === item.issue_count).status : item.status,
          old_lottery_status: (result.data && result.data.lotteryticket && result.data.lotteryticket.find(r => r.customer_id === item.customer_id && r.issue_count === item.issue_count)) ? item.lottery_status : item.old_lottery_status,
          upd_date: (result.data && result.data.lotteryticket && result.data.lotteryticket.find(r => r.customer_id === item.customer_id && r.issue_count === item.issue_count)) ? result.data.lotteryticket.find(r => r.customer_id === item.customer_id && r.issue_count === item.issue_count).upd_date : item.upd_date
        }));
        setCustomerTicketList(updatedList);
        if (updatedList.filter(x => x.lottery_status !== x.old_lottery_status).length <= 0) {
          setLotteryFlg(false);
        }
      }
    } catch (err) {
      console.log(util.inspect(err));
      if (err.response && err.response.data) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      setLockData(false);
      refreshMaster();
    }
  };

  useEffect(() => {
    async function fetchData() {
      await refreshMaster();
    }
    return fetchData();
  }, [refreshMaster]);

  const handleSelectEntry = async (benefit_lottery_ticket_id) => {
    if (benefit_lottery_ticket_id) {
      const params = {
        site_id: props.match.params.siteId,
        lottery_start: benefitTicketList.find(b => b.benefit_lottery_ticket_id === benefit_lottery_ticket_id)?.lottery_start,
        lottery_end: benefitTicketList.find(b => b.benefit_lottery_ticket_id === benefit_lottery_ticket_id)?.lottery_end,
      }
      const re = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/payment_amount/`, params,
        { headers: { Authorization: `Bearer ${jwt}` } }
      );
      const amountMap = {};
      const mallMap = {};
      re.data.forEach(row => {
        amountMap[row.customer_id] = row.total_amount;
        mallMap[row.customer_id] = row.mall_id;
      });
      setPrevMonthAmount(amountMap);
      setPrevMonthMall(mallMap);
      setSelectEntry(benefit_lottery_ticket_id);
    } else {
      setPrevMonthAmount({});
      setPrevMonthMall({});
      setSelectEntry(null);
    }
  }

  // const handleMonthChange = (selectedOption) => {
  //   const monthValue = selectedOption.value;
  //   const rankValue = selectedRank?.value ?? '';

  //   var filteredCustomer = originCustomerTicketList;
  //   var filteredBenefit = originBenefitTicketList;

  //   if (monthValue !== '') {
  //     filteredCustomer = filteredCustomer.filter(item => item.year_month === monthValue);
  //     filteredBenefit = filteredBenefit.filter(item => item.m_benefit_lottery_ticket_yearmonth.some(y => y.year_month === monthValue));
  //   }
  //   if (rankValue !== '') {
  //     filteredCustomer = filteredCustomer.filter(item => item.rank_id === rankValue);
  //     filteredBenefit = filteredBenefit.filter(item => item.rank_id === rankValue);
  //   }

  //   setCustomerTicketList(filteredCustomer);
  //   setBenefitTicketList(filteredBenefit);
  //   setSelectedMonth(selectedOption);
  // };

  const handleBackClick = () => {
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}customerrank`);
  }

  //抽選
  const setLottery = async () => {
    if (!selectEntry) {
      addToast("特典を選択してください。", { appearance: 'error', autoDismiss: true });
      return;
    }
    // 対象の特典情報
    const benefit = benefitTicketList.find(b => b.benefit_lottery_ticket_id === selectEntry);
    if (!benefit) {
      addToast("特典情報が見つかりません。", { appearance: 'error', autoDismiss: true });
      return;
    }
    // 対象の抽選券リスト
    const targetList = customerTicketList.filter(x => x.benefit_lottery_ticket_id === selectEntry);
    // 既に当選している数（statusまたはlottery_statusがWIN）
    const alreadyWinCount = targetList.filter(x => x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN || x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.USED || x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.SENT || x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.DELIVERY || x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN ||x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.DELIVERY || x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.SENT || x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.USED).length;

    // 当選枠
    var winMax = Number(benefit.limit_count) - alreadyWinCount;

    // 抽選対象（まだ当選していないもの）
    var candidates = targetList.filter(
      x => x.status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN && x.status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.USED && x.status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.SENT && x.status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.DELIVERY && x.lottery_status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN && x.lottery_status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.USED && x.lottery_status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.SENT && x.lottery_status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.DELIVERY
    );

    // 応募済のみ or 落選も含む
    if (lotteryTarget === constClass.FLAG.ON) {
      // 応募済のみ
      candidates = candidates.filter(x => x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED);
    } else {
      // 応募済＋落選
      candidates = candidates.filter(x => [constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED, constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE].includes(x.status));
    }

    // 前月決済金額が抽選条件金額以上の人だけ
    candidates = candidates.filter(x => {
      const amount = prevMonthAmount[x.customer_id] || 0;
      return amount >= Number(benefit.min_amount);
    });

    const notEnoughList = targetList
      .filter(x => {
        const amount = prevMonthAmount[x.customer_id] || 0;
        return amount < Number(benefit.min_amount)
          && [constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED, constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE].includes(x.status);
      })
      .map(x => x.customer_id + '_' + x.issue_count);

    // 既に当選している人を除外するため、selectedCustomerIdsに初期値をセット
    const selectedCustomerIds = new Set(
      targetList
        .filter(x => x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN || x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.USED || x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.SENT || x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.DELIVERY || x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN ||x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.DELIVERY || x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.SENT || x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.USED)
        .map(x => x.customer_id)
    );

    // 当選者をランダムに選ぶ
    var winList = [];
    if (winMax > 0 && candidates.length > 0) {
      const shuffled = [...candidates].sort(() => Math.random() - 0.5);
      for (const c of shuffled) {
        const key = c.customer_id + '_' + c.issue_count;
        if (!selectedCustomerIds.has(c.customer_id)) {
          winList.push(key);
          selectedCustomerIds.add(c.customer_id);
          if (winList.length >= winMax) break;
        }
      }
    }

    // 新しいリストを作成
    var changed = false;
    const newList = customerTicketList.map(item => {
      if (item.benefit_lottery_ticket_id !== selectEntry) return item;
      const key = item.customer_id + '_' + item.issue_count;
      if (winList.includes(key)) {
        if (item.lottery_status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN) changed = true;
        return { ...item, lottery_status: constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN };
      } else if (notEnoughList.includes(key)) {
        if (item.lottery_status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE) changed = true;
        return { ...item, lottery_status: constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE };
      } else if (candidates.some(x => x.customer_id === item.customer_id && x.issue_count === item.issue_count)) {
        if (item.lottery_status !== constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE) changed = true;
        return { ...item, lottery_status: constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE };
      }
      return item;
    });
    if (!changed) {
      addToast("変更ありませんでした。", { appearance: 'success', autoDismiss: true });
    } else {
      setCustomerTicketList(newList);
      setLotteryFlg(true);
      addToast("当落を設定しました。", { appearance: 'success', autoDismiss: true });
    }
    setLoscComfirmFlg(false);
  };

  const changeStatus = (data) => (event) => {
    //dataはt_benefit_lottery_ticket選択している特典の抽選券データ
    var max = Number(benefitTicketList.find(b => b.benefit_lottery_ticket_id === data.benefit_lottery_ticket_id).limit_count) - customerTicketList.filter(x => x.lottery_status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN).length;
    const target = event.target;
    var ticket = customerTicketList.concat();
    var idx = ticket.findIndex(x => x.customer_id === data.customer_id && x.issue_count === data.issue_count);
    if (Number(Number(benefitTicketList.find(b => b.benefit_lottery_ticket_id === data.benefit_lottery_ticket_id).limit_count)) > 0 && max <= 0 && ticket[idx].lottery_status !== target.value && target.value === constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN) {
      alert("当選者数が募集人数を超えるため変更できません。");
      return;
    }
    ticket[idx] = { ...data, lottery_status: target.value };
    var lottery_flg = (ticket.filter(x => x.lottery_status !== x.old_lottery_status).length > 0);
    setCustomerTicketList(ticket);
    setLotteryFlg(lottery_flg);
  }

  //検索条件による絞り込み反映
  const getTargetSearch = useCallback((benefit_lottery_ticket_id) => {
    if (!benefit_lottery_ticket_id) {
      return customerTicketList;
    } else {
      return customerTicketList.filter(x => x.benefit_lottery_ticket_id === benefit_lottery_ticket_id);
    }
  }, [customerTicketList]);

  // ソートデータ
  const sortData = useCallback((a, b) => {
    if (sortOrder.length <= 0) {
      return a.customer_id - b.customer_id;
    }
    for (var i = 0; i < sortOrder.length; i++) {
      var item = sortOrder[i];
      if (item.column === 'customer_id') {
        if (item.order === 'ASC') {
          if (a.customer_id < b.customer_id) return -1;
          if (a.customer_id > b.customer_id) return 1;
        }
        else {
          if (b.customer_id < a.customer_id) return -1;
          if (b.customer_id > a.customer_id) return 1;
        }
      } else if (item.column === 'status') { //ステータス
        const keylist = Object.keys(constClass.BENEFIT_LOTTERY_TICKET_STATUS);

        const aStatus = keylist.indexOf(a.status);
        const bStatus = keylist.indexOf(b.status);
        if (item.order === 'ASC') {
          if (aStatus < bStatus) return -1;
          if (aStatus > bStatus) return 1;
        } else {
          if (bStatus < aStatus) return -1;
          if (bStatus > aStatus) return 1;
        }
      } else {
        if (item.order === 'ASC') {
          if (a[item.column] < b[item.column]) return -1;
          if (a[item.column] > b[item.column]) return 1;
        } else {
          if (b[item.column] < a[item.column]) return -1;
          if (b[item.column] > a[item.column]) return 1;
        }
      }
    }
    return 0;
  }, [sortOrder]);

  // ヘッダーボタン（ソート）：処理
  const handleHeaderClick = (column) => {
    var _sortOrder = JSON.parse(JSON.stringify(sortOrder));
    if (_sortOrder.map(s => s.column).includes(column)) { // 既に登録済み
      if (_sortOrder[0].column !== column) { // 先頭ではない
        _sortOrder.splice(_sortOrder.findIndex(s => s.column === column), 1); //削除
        _sortOrder.unshift({ column, order: 'ASC' }); // 追加
      } else { //先頭 並び順変更
        _sortOrder[0].order = _sortOrder[0].order === 'ASC' ? 'DESC' : 'ASC';
      }
    } else { //未登録
      _sortOrder.unshift({ column, order: 'ASC' }); // 追加
    }
    if (_sortOrder.length > 3) { //ソート順は3件まで
      _sortOrder.pop();
    }
    setSortOrder(_sortOrder);
  }

  const renderSortTh = (column, column2 = null) => {
    if (column2 === null) {
      return (<th className="text-center align-middle like-button p-0 m-0" onClick={() => handleHeaderClick(column)}>
        {sortOrder.filter(s => s.column === column).map((item, idx, self) =>
          <span key={idx}>{item.order === 'ASC' ? '▲' : '▼'}{sortOrder.findIndex(s => s.column === column) + 1}</span>
        )}
      </th>)
    } else {
      return ""
    }
  }

  const renderList = () => {
    return (
      <div className='row'>
        <div className='col'>
          <div className='row mt-4 mb-2'>
            <div className='col-8'></div>
            <div className='col-4 align-self-center text-right'>
              <button
                disabled={lockData || getTargetSearch().length <= 0}
                className='btn btn-primary px-5 w-75'
                onClick={(e) => { setLoscComfirmFlg(true) }}
              >
                当落抽選
              </button>
            </div>
          </div>
          <div className="row p-0">
            <div className='col'>
              <table className="table table-bordered ">
                <thead className='table-success'>
                  <tr>
                    <td className="text-center" onClick={() => handleHeaderClick("customer_id")}>
                      ID
                    </td>
                    {benefitTicketList.find(b => b.benefit_lottery_ticket_id === selectEntry)?.receiving_type === constClass.RECEIVING_TYPE.TICKET_DELIVERY &&
                      <React.Fragment>
                        <td className="text-center" onClick={() => handleHeaderClick("phone_number")}>
                          電話番号
                        </td>
                        <td className="text-center" onClick={() => handleHeaderClick("email")}>
                          メールアドレス
                        </td>
                        <td className="text-center" onClick={() => handleHeaderClick("postal_code")}>
                          郵便番号
                        </td>
                        <td className="text-center" onClick={() => handleHeaderClick("address")}>
                          住所
                        </td>
                        <td className="text-center" onClick={() => handleHeaderClick("name")}>
                          氏名
                        </td>
                      </React.Fragment>
                    }
                    <td className="text-center" onClick={() => handleHeaderClick("status")}>
                      ステータス
                    </td>
                    <td className="text-center" onClick={() => handleHeaderClick("amount")}>
                      抽選期間決済金額
                    </td>
                    <td className="text-center" onClick={() => handleHeaderClick("status")}>
                      処理
                    </td>
                  </tr>
                  <tr className="print-none">
                    {renderSortTh('customer_id')}
                    {benefitTicketList.find(b => b.benefit_lottery_ticket_id === selectEntry)?.receiving_type === constClass.RECEIVING_TYPE.TICKET_DELIVERY &&
                      <React.Fragment>
                        {renderSortTh('phone_number')}
                        {renderSortTh('email')}
                        {renderSortTh('postal_code')}
                        {renderSortTh('address')}
                        {renderSortTh('name')}
                      </React.Fragment>
                    }
                    {renderSortTh('status')}
                    {renderSortTh('amount')}
                    {renderSortTh('lottery_status')}
                  </tr>
                </thead>
                <tbody>
                  {getTargetSearch(selectEntry).sort((a, b) => sortData(a, b)).map((data, idx) => (
                    <tr key={data.customer_id + '_' + data.issue_count} className={data.lottery_status !== data.old_lottery_status ? constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN === data.lottery_status ? 'bg-blue' : constClass.STATUS.REG === data.lottery_status ? "" : 'bg-dimgray' : ""}>
                      <td className="text-center align-middle">
                        {data.customer_id}
                      </td>
                      {benefitTicketList.find(b => b.benefit_lottery_ticket_id === selectEntry)?.receiving_type === constClass.RECEIVING_TYPE.TICKET_DELIVERY &&
                        <React.Fragment>
                          <td className="text-center align-middle">
                            {data.phone_number}
                          </td>
                          <td className="text-center align-middle">
                            {data.email}
                          </td>
                          <td className="text-center align-middle">
                            {data.postal_code}
                          </td>
                          <td className="text-center align-middle">
                            {data.address}
                          </td>
                          <td className="text-center align-middle">
                            {data.name}
                          </td>
                        </React.Fragment>
                      }
                      <td className={`text-center align-middle ${data.lottery_status !== data.old_lottery_status ? "" : constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN === data.lottery_status ? 'bg-lightblue' : [constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE].includes(data.lottery_status) ? 'bg-lightgray' : ""}`}>
                        {constClass.BENEFIT_LOTTERY_TICKET_STATUS_NAME[data.status]}
                      </td>
                      <td className="text-center align-middle">
                        {prevMonthAmount[data.customer_id] ? prevMonthAmount[data.customer_id].toLocaleString() + "円" : "0円"}
                      </td>
                      <td className="text-center align-middle">
                        {(data.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.USED || data.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.EXPIRED || data.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.CANCELED || data.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.SENT)
                          ? constClass.BENEFIT_LOTTERY_TICKET_STATUS_NAME[data.status]
                          : <select
                            className="form-control"
                            id={`lottery_status_${data.customer_id}_${data.issue_count}`}
                            name={`lottery_status_${data.customer_id}_${data.issue_count}`}
                            value={data.lottery_status}
                            onChange={changeStatus(data)}
                          >
                            <option value={constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED}>-- 選択 --</option>
                            <option value={constClass.BENEFIT_LOTTERY_TICKET_STATUS.WIN}>当選</option>
                            <option value={constClass.BENEFIT_LOTTERY_TICKET_STATUS.LOSE}>落選</option>
                          </select>
                        }
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </table>
            </div>
          </div>
          {(selectEntry) &&
            <div className='row'>
              <div className='col-8'>

              </div>
              <div className='col-4 align-self-center text-right'>
                <button
                  disabled={lockData || !lotteryFlg}
                  className='btn btn-primary px-5 w-75'
                  onClick={submitLottery}
                >
                  登録
                </button>
              </div>
            </div>
          }
        </div>
      </div >
    );
  }

  const renderListEntry = () => {
    return (
      <div className='row'>
        <div className="row col-12 mt-4 mb-2">
          <div className='col-2'>
            <button type="button"
              className={`btn btn-secondary mx-1 w-100 text-nowrap`}
              onClick={() => { handleBackClick() }}>
              戻る
            </button>
          </div>
        </div>
        <div className='col'>
          {benefitTicketList &&
            <table className="table table-bordered table-striped">
              <thead className='table-success'>
                <tr>
                  <th className="text-center">
                    特典タイトル
                  </th>
                  <th className="text-center">
                    抽選条件金額
                  </th>
                  <th className="text-center">
                    募集人数
                  </th>
                  <th className="text-center">
                    応募総数
                  </th>
                  <th className="text-center">
                    応募人数
                  </th>
                  <th className="text-center">
                    当選数
                  </th>
                  <th className="text-center">
                    落選数
                  </th>
                  <th className="text-center">
                    残数
                  </th>
                  <th className="text-center">

                  </th>
                </tr>
              </thead>
              <tbody>
                {(selectEntry ? benefitTicketList.filter(x => x.benefit_lottery_ticket_id === selectEntry) : benefitTicketList).map((item, idx) =>
                  <tr key={idx}>
                    <td>{item.benefit_lottery_ticket_title}</td>
                    <td className='text-right'>{item.min_amount}</td>
                    <td className='text-right'>{item.limit_count}</td>
                    <td className='text-right'>{getTargetSearch(item.benefit_lottery_ticket_id).length}</td>
                    <td className='text-right'>{getTargetSearch(item.benefit_lottery_ticket_id).map(item => item.customer_id).filter((value, index, self) => self.indexOf(value) === index).length}</td>
                    <td className='text-right'>{getTargetSearch(item.benefit_lottery_ticket_id).filter(d => d.lottery === constClass.FLAG.ON).length}</td>
                    <td className='text-right'>{getTargetSearch(item.benefit_lottery_ticket_id).filter(d => d.lottery === constClass.FLAG.OFF).length}</td>
                    <td className='text-right'>{item.limit_count - getTargetSearch(item.benefit_lottery_ticket_id).filter(d => d.lottery === constClass.FLAG.ON).length}</td>
                    <td className='text-center'>
                      {!selectEntry && <button
                        className='btn btn-primary'
                        onClick={e => handleSelectEntry(item.benefit_lottery_ticket_id)}
                      >詳細</button>}
                      {selectEntry && <button
                        className='btn btn-primary'
                        onClick={e => handleSelectEntry('')}
                      >戻る</button>}
                    </td>
                  </tr>
                )}
                {!selectEntry &&
                  <tr>
                    <td>合計</td>
                    <td></td>
                    <td className='text-right'>{benefitTicketList.reduce((prev, s) => prev + s.limit_count, 0)}</td>
                    <td className='text-right'>{getTargetSearch().length}</td>
                    <td className='text-right'>{new Set(getTargetSearch().map(item => `${item.benefit_lottery_ticket_id}_${item.customer_id}`)).size}</td>
                    <td className='text-right'>{getTargetSearch().filter(d => d.lottery === constClass.FLAG.ON).length}</td>
                    <td className='text-right'>{getTargetSearch().filter(d => d.lottery === constClass.FLAG.OFF).length}</td>
                    <td className='text-right'>{benefitTicketList.reduce((prev, s) => prev + s.limit_count, 0) - getTargetSearch().filter(d => d.lottery === constClass.FLAG.ON).length}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    );
  }

  const renderLoscComfirm = () => {
    return (
      <Modal isOpen={loscComfirmFlg} style={modalConfirmStyle}>
        <div className="modal-body">
          <div className="row my-3">
            <div className="col-4 pt-1 text-right">
              <span>抽選対象</span>
            </div>
            <div className="col-6">
              <div className='row m-0 p-0'>
                <div className="col-1 px-0"><input type="radio" className={`form-control`} id={"lottery_target_1"} name={"lottery_target"} value={constClass.FLAG.OFF} checked={lotteryTarget === constClass.FLAG.OFF} onChange={(event) => setLotteryTarget(constClass.FLAG.OFF)}></input></div>
                <div className="col-5 px-1 pt-1"><label htmlFor={"lottery_target_1"}>応募済+落選</label></div>
                <div className="col-1 px-0"><input type="radio" className={`form-control`} id={"lottery_target_2"} name={"lottery_target"} value={constClass.FLAG.ON} checked={lotteryTarget === constClass.FLAG.ON} onChange={(event) => setLotteryTarget(constClass.FLAG.ON)}></input></div>
                <div className="col-5 px-2 pt-1"><label htmlFor={"lottery_target_2"}>応募済のみ</label></div>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12 text-center text-info">
              抽選条件： 抽選期間 {benefitTicketList?.find(b => b.benefit_lottery_ticket_id === selectEntry)?.lottery_start}〜{benefitTicketList?.find(b => b.benefit_lottery_ticket_id === selectEntry)?.lottery_end}
            </div>
            <div className="col-12 text-center text-info">
              決済金額 {benefitTicketList?.find(b => b.benefit_lottery_ticket_id === selectEntry)?.min_amount?.toLocaleString() || 0} 円以上の方が対象です
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12 text-center p-4">
              <button className='btn btn-primary py-3 w-100' onClick={(e) => setLottery()}>抽選実行</button>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { setLoscComfirmFlg(false) }}>Close</button>
        </div>
      </Modal>
    )
  }

  return (
    <div className="container mt-2">
      {customerTicketList && renderListEntry()}
      {customerTicketList && selectEntry && renderList()}
      {loscComfirmFlg && renderLoscComfirm()}
      {lockData && <Loading />}
    </div>
  );
}

export default Lottery;